<template>
  <div v-if="successRecord" class="person-in-success">
    <button type="button" class="back-btn" @click="exitSuccess">
      <van-icon name="arrow-left" />
    </button>

    <div class="success-panel">
      <div class="success-icon">
        <van-icon name="success" color="#18c45c" size="66" />
      </div>
      <div class="success-title">登记成功，欢迎入场！</div>
      <div class="success-meta">姓名：{{ successRecord.name }}</div>
      <div class="success-meta">
        入场时间：{{ formatTime(successRecord.passOrRegisterTime || successRecord.submitTime) }}
      </div>

      <div class="success-links">
        <button type="button" @click="openRecordDetail(successRecord)">查看填写详情</button>
        <span>|</span>
        <button type="button" @click="$toast('当前版本仅保留入口文字')">订阅后续动态</button>
      </div>

      <van-button round block class="success-action" @click="exitSuccess">
        完成，请点击退出
      </van-button>
    </div>

    <van-popup
      v-model="showDetailPopup"
      position="bottom"
      round
      :style="{ height: '72%' }"
    >
      <div class="record-popup">
        <div class="record-popup__header">
          <h3>填写详情</h3>
          <van-icon name="cross" @click="showDetailPopup = false" />
        </div>
        <div v-if="detailRecord" class="detail-list">
          <div class="detail-row">
            <span>姓名</span>
            <strong>{{ detailRecord.name || '-' }}</strong>
          </div>
          <div class="detail-row">
            <span>身份证号</span>
            <strong>{{ detailRecord.idCardNo || '-' }}</strong>
          </div>
          <div class="detail-row">
            <span>手机号码</span>
            <strong>{{ detailRecord.phoneNumber || '-' }}</strong>
          </div>
          <div class="detail-row">
            <span>单位/个人</span>
            <strong>{{ getCompanyTypeText(detailRecord.companyTypeCode) }}</strong>
          </div>
          <div class="detail-row">
            <span>公司/单位名称</span>
            <strong>{{ detailRecord.companyName || '-' }}</strong>
          </div>
          <div class="detail-row">
            <span>来访事由</span>
            <strong>{{ getVisitReasonText(detailRecord.reasonCode) }}</strong>
          </div>
          <div class="detail-row">
            <span>其他事由</span>
            <strong>{{ detailRecord.reasonOther || '-' }}</strong>
          </div>
          <div class="detail-row">
            <span>入场时间</span>
            <strong>{{ formatTime(detailRecord.passOrRegisterTime || detailRecord.submitTime) }}</strong>
          </div>
          <div class="detail-row detail-row--block">
            <span>来访凭证照片</span>
            <img
              v-if="detailRecord.visitVoucherImageUrl"
              :src="detailRecord.visitVoucherImageUrl"
              alt="来访凭证照片"
              class="detail-image"
              @click="previewImage(detailRecord.visitVoucherImageUrl)"
            />
            <strong v-else>-</strong>
          </div>
        </div>
      </div>
    </van-popup>
  </div>

  <div v-else class="person-in-page">
    <!--section class="page-hero">
      <h3>外来人员入场信息登记</h3>
      <p>按要求填写入场信息，提交成功后即可查看本机最近填写记录和详情。</p>
    </section-->

    <section class="record-card">
      <div class="record-card__header">
        <h3>我的填写记录</h3>
      </div>

      <div v-if="latestRecord" class="record-summary" @click="openRecordDetail(latestRecord)">
        <div class="record-summary__time">
          {{ formatSummaryTime(latestRecord.passOrRegisterTime || latestRecord.submitTime) }}
          {{ latestRecord.name }} 填写了外来人员入场登记
        </div>
        <div class="record-summary__meta">姓名：{{ latestRecord.name }}</div>
        <div class="record-summary__meta">手机号码：{{ latestRecord.phoneNumber }}</div>
        <div class="record-summary__meta">来访事由：{{ getVisitReasonText(latestRecord.reasonCode) }}</div>
      </div>
      <van-empty
        v-else
        image="search"
        description="当前设备暂无填写记录"
      />

      <button
        type="button"
        class="record-card__footer"
        @click="showRecordsPopup = true"
      >
        全部{{ records.length }}条
      </button>
    </section>

    <section class="form-card">
      <!--div class="form-card__title">
        <h3>外来人员入场登记</h3>
        <span>你共填过 {{ records.length }} 次</span>
      </div-->

      <van-form @submit="openConfirmDialog">
        <div class="form-block">
          <div class="field-label">姓名 <span class="required">*</span></div>
          <van-field
            v-model.trim="form.name"
            name="name"
            maxlength="24"
            placeholder="请填写真实姓名，以便核验"
            :rules="[{ required: true, message: '请输入姓名' }]"
          />
          <div v-if="recentNameValue" class="history-fill">
            <span>最近输入：{{ recentNameValue }}</span>
            <button type="button" @click="form.name = recentNameValue">填入</button>
          </div>
        </div>

        <div class="form-block">
          <div class="field-label">身份证号 <span class="required">*</span></div>
          <van-field
            v-model.trim="form.idCardNo"
            name="idCardNo"
            maxlength="18"
            placeholder="请输入身份证号"
            :rules="[
              { required: true, message: '请输入身份证号' },
              { validator: validateIdCard, message: '请输入正确的身份证号' }
            ]"
          />
          <div v-if="recentIdCardValue" class="history-fill">
            <span>最近输入：{{ recentIdCardValue }}</span>
            <button type="button" @click="form.idCardNo = recentIdCardValue">填入</button>
          </div>
        </div>

        <div class="form-block">
          <div class="field-label">手机号码 <span class="required">*</span></div>
          <div class="phone-row">
            <van-field
              v-model.trim="form.phoneNumber"
              name="phoneNumber"
              readonly
              clickable
              placeholder="请点击右侧按钮获取微信手机号"
              class="phone-field"
            />
            <van-button
              class="fetch-phone-btn"
              type="primary"
              plain
              round
              :loading="fetchingPhone"
              :disabled="fetchingPhone"
              @click.prevent="fetchPhoneNumber"
            >
              {{ fetchingPhone ? '获取中...' : '获取手机号' }}
            </van-button>
          </div>
        </div>

        <div class="form-block">
          <div class="field-label">单位/个人 <span class="required">*</span></div>
          <van-field
            readonly
            clickable
            is-link
            :value="getCompanyTypeText(form.companyTypeCode)"
            placeholder="请选择单位或个人"
            @click="showCompanyTypePopup = true"
          />
        </div>

        <div v-if="form.companyTypeCode === 'unit'" class="form-block">
          <div class="field-label">公司或单位名称 <span class="required">*</span></div>
          <van-field
            v-model.trim="form.companyName"
            name="companyName"
            maxlength="100"
            placeholder="请输入公司或单位名称"
            :rules="[{ required: true, message: '请输入公司或单位名称' }]"
          />
        </div>

        <div class="form-block">
          <div class="field-label">来访事由 <span class="required">*</span></div>
          <van-field
            readonly
            clickable
            is-link
            :value="getVisitReasonText(form.reasonCode)"
            placeholder="请选择来访事由"
            @click="showVisitReasonPopup = true"
          />
        </div>

        <div v-if="form.reasonCode === 'other'" class="form-block">
          <div class="field-label">其他事由 <span class="required">*</span></div>
          <van-field
            v-model.trim="form.reasonOther"
            name="reasonOther"
            maxlength="200"
            placeholder="请填写具体来访事由"
            :rules="[{ required: true, message: '请输入其他事由' }]"
          />
        </div>

        <div class="form-block">
          <div class="field-label">入场时间 <span class="required">*</span></div>
          <van-field
            :value="displayPassTime"
            readonly
            clickable
            is-link
            @click="openPassTimePicker"
          />
        </div>

        <div class="form-block">
          <div class="field-label">来访凭证照片 <span class="required">*</span></div>
          <van-uploader
            v-model="voucherFileList"
            :after-read="handleVoucherAfterRead"
            :max-count="1"
            accept="image/*"
            upload-text="拍照或从相册选择"
          />
          <div class="field-hint">当前版本正式上传后台，请至少上传 1 张凭证照片。</div>
        </div>

        <div class="submit-wrap">
          <van-button round block native-type="submit" class="submit-btn">
            提交登记
          </van-button>
        </div>
      </van-form>
    </section>

    <van-popup
      v-model="showConfirmPopup"
      position="center"
      round
      :style="{ width: '90%', maxWidth: '420px' }"
    >
      <div class="custom-confirm-dialog">
        <div class="confirm-icon">
          <van-icon name="warning-o" color="#ffb020" size="52" />
        </div>
        <div class="confirm-title">请确认登记信息</div>
        <div class="confirm-details">
          <div class="detail-item">
            <span class="detail-label">姓名</span>
            <span class="detail-value">{{ form.name }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">身份证号</span>
            <span class="detail-value">{{ form.idCardNo }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">手机号码</span>
            <span class="detail-value">{{ form.phoneNumber }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">来访事由</span>
            <span class="detail-value">{{ getVisitReasonText(form.reasonCode) }}</span>
          </div>
        </div>
        <div class="confirm-actions">
          <van-button round type="default" @click="showConfirmPopup = false">取消</van-button>
          <van-button round color="#16a56f" :loading="submitting" @click="submitPersonIn">确认提交</van-button>
        </div>
      </div>
    </van-popup>

    <van-popup
      v-model="showCompanyTypePopup"
      position="bottom"
      round
      :style="{ maxHeight: '60%' }"
    >
      <div class="picker-popup">
        <div class="picker-popup__header">
          <h3>选择单位/个人</h3>
          <van-icon name="cross" @click="showCompanyTypePopup = false" />
        </div>
        <div
          v-for="item in companyTypeOptions"
          :key="item.code"
          class="picker-option"
          @click="selectCompanyType(item.code)"
        >
          <span>{{ item.description }}</span>
          <van-icon v-if="form.companyTypeCode === item.code" name="success" color="#16a56f" />
        </div>
      </div>
    </van-popup>

    <van-popup
      v-model="showVisitReasonPopup"
      position="bottom"
      round
      :style="{ maxHeight: '65%' }"
    >
      <div class="picker-popup">
        <div class="picker-popup__header">
          <h3>选择来访事由</h3>
          <van-icon name="cross" @click="showVisitReasonPopup = false" />
        </div>
        <div
          v-for="item in visitReasonOptions"
          :key="item.code"
          class="picker-option"
          @click="selectVisitReason(item.code)"
        >
          <span>{{ item.description }}</span>
          <van-icon v-if="form.reasonCode === item.code" name="success" color="#16a56f" />
        </div>
      </div>
    </van-popup>

    <van-popup
      v-model="showPassTimePopup"
      position="bottom"
      round
      :style="{ maxHeight: '72%' }"
    >
      <div class="datetime-popup">
        <div class="picker-popup__header">
          <h3>选择入场时间</h3>
          <van-icon name="cross" @click="showPassTimePopup = false" />
        </div>
        <van-datetime-picker
          v-model="passTimePickerValue"
          type="datetime"
          title=""
          :show-toolbar="false"
          :min-date="minPassTime"
          :max-date="maxPassTime"
          :formatter="formatPassTimePickerColumn"
        />
        <div class="datetime-popup__actions">
          <van-button round type="default" @click="showPassTimePopup = false">取消</van-button>
          <van-button round color="#16a56f" @click="confirmPassTime">确定</van-button>
        </div>
      </div>
    </van-popup>

    <van-popup
      v-model="showRecordsPopup"
      position="bottom"
      round
      :style="{ height: '72%' }"
    >
      <div class="record-popup">
        <div class="record-popup__header">
          <h3>我的填写记录</h3>
          <van-icon name="cross" @click="showRecordsPopup = false" />
        </div>
        <div v-if="records.length" class="record-list">
          <div
            v-for="record in records"
            :key="record.id || record.recordNo"
            class="record-list__item"
            @click="openRecordDetail(record)"
          >
            <div class="record-list__title">{{ formatSummaryTime(record.passOrRegisterTime || record.submitTime) }}</div>
            <div class="record-list__desc">{{ record.name }} · {{ getVisitReasonText(record.reasonCode) }}</div>
          </div>
        </div>
        <van-empty
          v-else
          image="search"
          description="暂无填写记录"
        />
      </div>
    </van-popup>

    <van-popup
      v-model="showDetailPopup"
      position="bottom"
      round
      :style="{ height: '72%' }"
    >
      <div class="record-popup">
        <div class="record-popup__header">
          <h3>填写详情</h3>
          <van-icon name="cross" @click="showDetailPopup = false" />
        </div>
        <div v-if="detailRecord" class="detail-list">
          <div class="detail-row">
            <span>姓名：{{ detailRecord.name || '-' }}</span>
            <!--strong>{{ detailRecord.name || '-' }}</strong-->
          </div>
          <div class="detail-row">
            <span>身份证号：{{ detailRecord.idCardNo || '-' }}</span>
            <!--strong>{{ detailRecord.idCardNo || '-' }}</strong-->
          </div>
          <div class="detail-row">
            <span>手机号码：{{ detailRecord.phoneNumber || '-' }}</span>
            <!--strong>{{ detailRecord.phoneNumber || '-' }}</strong-->
          </div>
          <div class="detail-row">
            <span>单位/个人：{{ getCompanyTypeText(detailRecord.companyTypeCode) }}</span>
            <!--strong>{{ getCompanyTypeText(detailRecord.companyTypeCode) }}</strong-->
          </div>
          <div class="detail-row">
            <span>公司/单位名称：{{ detailRecord.companyName || '-' }}</span>
            <!--strong>{{ detailRecord.companyName || '-' }}</strong-->
          </div>
          <div class="detail-row">
            <span>来访事由：{{ getVisitReasonText(detailRecord.reasonCode) }}</span>
            <!--strong>{{ getVisitReasonText(detailRecord.reasonCode) }}</strong-->
          </div>
          <div class="detail-row">
            <span>其他事由：{{ detailRecord.reasonOther || '-' }}</span>
            <!--strong>{{ detailRecord.reasonOther || '-' }}</strong-->
          </div>
          <div class="detail-row">
            <span>入场时间：{{ formatTime(detailRecord.passOrRegisterTime || detailRecord.submitTime) }}</span>
            <!--strong>{{ formatTime(detailRecord.passOrRegisterTime || detailRecord.submitTime) }}</strong-->
          </div>
          <div class="detail-row detail-row--block">
            <span>来访凭证照片</span>
            <img
              v-if="detailRecord.visitVoucherImageUrl"
              :src="detailRecord.visitVoucherImageUrl"
              alt="来访凭证照片"
              class="detail-image"
              @click="previewImage(detailRecord.visitVoucherImageUrl)"
            />
            <strong v-else>-</strong>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import axios from '@/utils/request';
import globalDic, { fetchMultiDic } from '@/utils/dic';
import {
  appendModuleRecord,
  cacheRecentFormValues,
  getCachedPhone,
  getDeviceVisitorId,
  getLatestRecord,
  getModuleRecords,
  getRecentValues,
  mergeModuleRecords,
  setCachedPhone
} from '@/utils/accessRegistration';

const MODULE_TYPE = 'person_in';
const FORM_DRAFT_KEY = `accessRegistrationDraft:${MODULE_TYPE}`;
const DEFAULT_COMPANY_TYPE_OPTIONS = [
  { code: 'unit', description: '单位' },
  { code: 'personal', description: '个人' }
];
const DEFAULT_VISIT_REASON_OPTIONS = [
  { code: 'business', description: '业务办理' },
  { code: 'pickup', description: '接送人员' },
  { code: 'visit', description: '来访拜访' },
  { code: 'other', description: '其他（填写具体事由）' }
];

function createDefaultForm() {
  return {
    name: '',
    idCardNo: '',
    phoneNumber: '',
    companyTypeCode: '',
    companyName: '',
    reasonCode: '',
    reasonOther: '',
    passOrRegisterTime: new Date().toISOString()
  };
}

export default {
  name: 'AccessRegistrationPersonIn',
  data() {
    return {
      deviceVisitorId: '',
      form: createDefaultForm(),
      fetchingPhone: false,
      submitting: false,
      showConfirmPopup: false,
      showCompanyTypePopup: false,
      showVisitReasonPopup: false,
      showPassTimePopup: false,
      showRecordsPopup: false,
      showDetailPopup: false,
      passTimePickerValue: new Date(),
      companyTypeOptionsState: [],
      visitReasonOptionsState: [],
      voucherFileList: [],
      voucherFile: null,
      records: [],
      latestRecord: null,
      detailRecord: null,
      successRecord: null
    };
  },
  computed: {
    companyTypeOptions() {
      return this.companyTypeOptionsState;
    },
    visitReasonOptions() {
      return this.visitReasonOptionsState;
    },
    recentNameValue() {
      return getRecentValues(MODULE_TYPE, 'name')[0] || '';
    },
    recentIdCardValue() {
      return getRecentValues(MODULE_TYPE, 'idCardNo')[0] || '';
    },
    displayPassTime() {
      return this.formatTime(this.form.passOrRegisterTime);
    },
    minPassTime() {
      const value = new Date();
      value.setFullYear(value.getFullYear() - 1);
      return value;
    },
    maxPassTime() {
      const value = new Date();
      value.setFullYear(value.getFullYear() + 2);
      return value;
    }
  },
  mounted() {
    this.deviceVisitorId = getDeviceVisitorId();
    this.restoreDraft();
    this.form.phoneNumber = this.form.phoneNumber || getCachedPhone() || '';
    this.consumePhoneFromRoute();
    this.bootstrapPage();
    window.addEventListener('beforeunload', this.persistDraft);
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.persistDraft);
  },
  watch: {
    '$route.query.mpPhone'() {
      this.consumePhoneFromRoute();
    },
    form: {
      handler() {
        this.persistDraft();
      },
      deep: true
    }
  },
  methods: {
    async bootstrapPage() {
      let dicResult = {};

      try {
        dicResult = await fetchMultiDic(['D_Access_CompanyType', 'D_Access_PersonVisitReason']);
      } catch (error) {
        dicResult = {};
      }

      this.companyTypeOptionsState = (dicResult.D_Access_CompanyType && dicResult.D_Access_CompanyType.length)
        ? dicResult.D_Access_CompanyType
        : (globalDic.D_Access_CompanyType && globalDic.D_Access_CompanyType.length)
          ? globalDic.D_Access_CompanyType
          : DEFAULT_COMPANY_TYPE_OPTIONS;
      this.visitReasonOptionsState = (dicResult.D_Access_PersonVisitReason && dicResult.D_Access_PersonVisitReason.length)
        ? dicResult.D_Access_PersonVisitReason
        : (globalDic.D_Access_PersonVisitReason && globalDic.D_Access_PersonVisitReason.length)
          ? globalDic.D_Access_PersonVisitReason
          : DEFAULT_VISIT_REASON_OPTIONS;
      await this.loadRecords();
    },
    persistDraft() {
      const draft = {
        ...this.form,
        phoneNumber: this.form.phoneNumber || getCachedPhone() || ''
      };
      localStorage.setItem(FORM_DRAFT_KEY, JSON.stringify(draft));
    },
    restoreDraft() {
      try {
        const draftText = localStorage.getItem(FORM_DRAFT_KEY);
        if (!draftText) {
          return;
        }

        const draft = JSON.parse(draftText);
        this.form = {
          ...createDefaultForm(),
          ...draft
        };
      } catch (error) {
        localStorage.removeItem(FORM_DRAFT_KEY);
      }
    },
    clearDraft() {
      localStorage.removeItem(FORM_DRAFT_KEY);
    },
    validateIdCard(value) {
      return /(^\d{15}$)|(^\d{17}(\d|X|x)$)/.test(String(value || '').trim());
    },
    selectCompanyType(code) {
      this.form.companyTypeCode = code;
      if (code !== 'unit') {
        this.form.companyName = '';
      }
      this.showCompanyTypePopup = false;
    },
    selectVisitReason(code) {
      this.form.reasonCode = code;
      if (code !== 'other') {
        this.form.reasonOther = '';
      }
      this.showVisitReasonPopup = false;
    },
    getCompanyTypeText(code) {
      const item = this.companyTypeOptions.find(option => option.code === code);
      return item ? item.description : '';
    },
    getVisitReasonText(code) {
      const item = this.visitReasonOptions.find(option => option.code === code);
      return item ? item.description : '';
    },
    formatTime(value) {
      if (!value) {
        return '';
      }

      const date = new Date(value);
      if (Number.isNaN(date.getTime())) {
        return value;
      }

      const yy = date.getFullYear();
      const mm = `${date.getMonth() + 1}`.padStart(2, '0');
      const dd = `${date.getDate()}`.padStart(2, '0');
      const hh = `${date.getHours()}`.padStart(2, '0');
      const mi = `${date.getMinutes()}`.padStart(2, '0');
      return `${yy}-${mm}-${dd} ${hh}:${mi}`;
    },
    formatPassTimePickerColumn(type, value) {
      if (type === 'year') {
        return `${value}年`;
      }
      if (type === 'month') {
        return `${value}月`;
      }
      if (type === 'day') {
        return `${value}日`;
      }
      if (type === 'hour') {
        return `${value}时`;
      }
      if (type === 'minute') {
        return `${value}分`;
      }
      return value;
    },
    openPassTimePicker() {
      const current = new Date(this.form.passOrRegisterTime);
      this.passTimePickerValue = Number.isNaN(current.getTime()) ? new Date() : current;
      this.showPassTimePopup = true;
    },
    confirmPassTime() {
      this.form.passOrRegisterTime = this.passTimePickerValue.toISOString();
      this.showPassTimePopup = false;
    },
    formatSummaryTime(value) {
      if (!value) {
        return '';
      }

      const date = new Date(value);
      if (Number.isNaN(date.getTime())) {
        return value;
      }

      const now = new Date();
      const sameDay =
        now.getFullYear() === date.getFullYear() &&
        now.getMonth() === date.getMonth() &&
        now.getDate() === date.getDate();

      const hh = `${date.getHours()}`.padStart(2, '0');
      const mi = `${date.getMinutes()}`.padStart(2, '0');
      return sameDay
        ? `今天 ${hh}:${mi}`
        : `${date.getMonth() + 1}月${date.getDate()}日 ${hh}:${mi}`;
    },
    previewImage(url) {
      if (!url) {
        return;
      }

      if (window.ImagePreview) {
        window.ImagePreview([url]);
        return;
      }

      this.$imagePreview([url]);
    },
    handleVoucherAfterRead(file) {
      this.voucherFile = file.file;
    },
    async loadRecords() {
      let records = getModuleRecords(MODULE_TYPE);

      try {
        const response = await axios.post('/api/AccessRegistration/MyRecords', {
          moduleType: MODULE_TYPE,
          deviceVisitorId: this.deviceVisitorId,
          pageSize: 20
        });

        if (response && response.data && response.data.success) {
          const items = (response.data.data && response.data.data.items) || [];
          records = mergeModuleRecords(MODULE_TYPE, items);
        }
      } catch (error) {
        records = mergeModuleRecords(MODULE_TYPE, records);
      }

      this.records = records;
      this.latestRecord = getLatestRecord(MODULE_TYPE);
    },
    openRecordDetail(record) {
      if (!record) {
        return;
      }

      this.detailRecord = record;
      this.showRecordsPopup = false;
      this.showDetailPopup = true;
    },
    isMiniProgramWebView() {
      if (typeof window === 'undefined') {
        return false;
      }

      const ua = window.navigator.userAgent || '';
      const hasBridge = !!(window.wx && window.wx.miniProgram);
      return hasBridge || window.__wxjs_environment === 'miniprogram' || /miniprogram/i.test(ua);
    },
    getMiniProgramBridge() {
      if (typeof window === 'undefined' || !window.wx || !window.wx.miniProgram) {
        return null;
      }

      return window.wx.miniProgram;
    },
    requestPhoneFromMiniProgram() {
      const miniProgram = this.getMiniProgramBridge();
      if (!miniProgram || typeof miniProgram.navigateTo !== 'function') {
        return false;
      }

      this.persistDraft();
      const target = this.$route.fullPath || '/home/access-registration/person-in';
      miniProgram.navigateTo({
        url: `/pages/phone-auth/index?target=${encodeURIComponent(target)}`
      });

      return true;
    },
    consumePhoneFromRoute() {
      const { mpPhone, mpPhoneError } = this.$route.query || {};

      if (mpPhone && /^1\d{10}$/.test(mpPhone)) {
        this.form.phoneNumber = String(mpPhone).trim();
        setCachedPhone(this.form.phoneNumber);
        this.clearPhoneBridgeQuery();
        this.$toast.success('手机号已自动填入');
        return;
      }

      if (mpPhoneError) {
        const message = decodeURIComponent(mpPhoneError);
        this.clearPhoneBridgeQuery();
        this.$toast.fail(message || '获取手机号失败');
      }
    },
    clearPhoneBridgeQuery() {
      const query = { ...(this.$route.query || {}) };
      delete query.mpPhone;
      delete query.mpPhoneError;
      delete query.mpPhoneSource;

      this.$router.replace({
        path: this.$route.path,
        query
      }).catch(() => {});
    },
    async fetchPhoneNumber() {
      if (this.fetchingPhone) {
        return;
      }

      this.fetchingPhone = true;

      try {
        if (this.isMiniProgramWebView() && this.requestPhoneFromMiniProgram()) {
          this.$toast.loading({
            message: '正在拉起微信手机号授权',
            forbidClick: true,
            duration: 1200
          });
          return;
        }

        this.$toast.fail('当前环境不支持微信手机号授权');
      } finally {
        this.fetchingPhone = false;
      }
    },
    validateBeforeConfirm() {
      if (!this.form.name) {
        this.$toast.fail('请输入姓名');
        return false;
      }

      if (!this.validateIdCard(this.form.idCardNo)) {
        this.$toast.fail('请输入正确的身份证号');
        return false;
      }

      if (!/^1\d{10}$/.test(this.form.phoneNumber || '')) {
        this.$toast.fail('请先获取手机号');
        return false;
      }

      if (!this.form.companyTypeCode) {
        this.$toast.fail('请选择单位或个人');
        return false;
      }

      if (this.form.companyTypeCode === 'unit' && !this.form.companyName) {
        this.$toast.fail('请输入公司或单位名称');
        return false;
      }

      if (!this.form.reasonCode) {
        this.$toast.fail('请选择来访事由');
        return false;
      }

      if (this.form.reasonCode === 'other' && !this.form.reasonOther) {
        this.$toast.fail('请输入其他事由');
        return false;
      }

      if (!this.voucherFile) {
        this.$toast.fail('请上传来访凭证照片');
        return false;
      }

      return true;
    },
    openConfirmDialog() {
      if (!this.validateBeforeConfirm()) {
        return;
      }

      this.showConfirmPopup = true;
    },
    async submitPersonIn() {
      if (this.submitting) {
        return;
      }

      this.submitting = true;
      this.$toast.loading({
        message: '提交中...',
        forbidClick: true,
        duration: 0
      });

      try {
        const formData = new FormData();
        formData.append('moduleType', MODULE_TYPE);
        formData.append('deviceVisitorId', this.deviceVisitorId);
        formData.append('name', this.form.name);
        formData.append('idCardNo', this.form.idCardNo);
        formData.append('phoneNumber', this.form.phoneNumber);
        formData.append('companyTypeCode', this.form.companyTypeCode);
        formData.append('companyName', this.form.companyName || '');
        formData.append('reasonCode', this.form.reasonCode);
        formData.append('reasonOther', this.form.reasonOther || '');
        formData.append('passOrRegisterTime', this.form.passOrRegisterTime);
        formData.append('visitVoucherPhoto', this.voucherFile);

        const response = await axios.post('/api/AccessRegistration/AddPersonIn', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        if (!response || !response.data || !response.data.success) {
          this.$toast.fail((response && response.data && response.data.message) || '提交失败');
          return;
        }

        const record = response.data.data || {};
        appendModuleRecord(MODULE_TYPE, record);
        cacheRecentFormValues(MODULE_TYPE, this.form);
        this.records = getModuleRecords(MODULE_TYPE);
        this.latestRecord = getLatestRecord(MODULE_TYPE);
        this.successRecord = record;
        this.showConfirmPopup = false;
        this.clearDraft();
      } catch (error) {
        this.$toast.fail('提交失败，请稍后重试');
      } finally {
        this.submitting = false;
        this.$toast.clear();
      }
    },
    exitSuccess() {
      this.successRecord = null;
      this.resetForm();
      this.loadRecords();
    },
    resetForm() {
      this.form = {
        ...createDefaultForm(),
        phoneNumber: getCachedPhone() || ''
      };
      this.voucherFileList = [];
      this.voucherFile = null;
      this.passTimePickerValue = new Date();
      this.clearDraft();
    }
  }
};
</script>

<style scoped>
.person-in-page,
.person-in-success {
  min-height: 100%;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.page-hero,
.record-card,
.form-card {
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid rgba(215, 229, 251, 0.96);
  box-shadow: var(--shadow-card);
}

.page-hero {
  padding: 26px 22px;
  background:
    radial-gradient(circle at top left, rgba(255, 255, 255, 0.28), transparent 28%),
    linear-gradient(180deg, #d7ecff 0%, #c8e3fb 100%);
}

.page-hero h2 {
  margin: 0 0 10px;
  font-size: 30px;
  line-height: 1.18;
  color: #1d5faf;
}

.page-hero h3 {
  margin: 0 0 10px;
  font-size: 25px;
  line-height: 1.18;
  color: #1d5faf;
}

.page-hero p {
  margin: 0;
  color: #4a6f94;
  line-height: 1.7;
  font-size: 14px;
}

.record-card,
.form-card {
  padding: 10px 12px;
}

.record-card__header,
.form-card__title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}

.record-card__header h3,
.form-card__title h3 {
  margin: 0;
  font-size: 18px;
  color: var(--text-primary);
}

.form-card__title span {
  font-size: 12px;
  color: var(--text-muted);
  padding: 4px 8px;
  border-radius: 999px;
  background: #f2f6fc;
}

.record-summary {
  padding: 10px 12px;
  border-radius: 14px;
  border: 1px solid #e4edf9;
  background: #fff;
}

.record-summary__time {
  color: #8c8f96;
  line-height: 1.35;
  margin-bottom: 6px;
  font-size: 12px;
}

.record-summary__meta {
  color: #1f2633;
  font-size: 14px;
  line-height: 1.4;
  font-weight: 600;
}

.record-card__footer {
  margin-top: 8px;
  width: 100%;
  border: none;
  border-radius: 12px;
  background: #f7f9fc;
  color: #5c7ca7;
  font-size: 14px;
  line-height: 38px;
}

.form-block + .form-block {
  margin-top: 18px;
}

.field-label {
  margin-bottom: 10px;
  color: var(--text-primary);
  font-size: 15px;
  font-weight: 700;
}

.required {
  color: #ee0a24;
}

.history-fill {
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  color: var(--text-muted);
  font-size: 12px;
}

.history-fill button {
  border: none;
  padding: 6px 12px;
  border-radius: 999px;
  color: #1d5faf;
  background: #edf4ff;
  font-size: 12px;
  font-weight: 700;
}

.phone-row {
  display: flex;
  gap: 10px;
  align-items: stretch;
}

.phone-field {
  flex: 1;
}

.fetch-phone-btn {
  min-width: 118px;
  height: auto;
  flex-shrink: 0;
  color: #fff !important;
}

.field-hint {
  margin-top: 8px;
  color: var(--text-muted);
  font-size: 12px;
  line-height: 1.6;
}

.submit-wrap {
  margin-top: 24px;
}

.submit-btn {
  height: 50px;
  font-size: 16px;
  font-weight: 700;
  color: #fff !important;
  background: linear-gradient(135deg, #1cb76a 0%, #168d56 100%) !important;
  border: none !important;
  box-shadow: 0 14px 28px rgba(22, 141, 86, 0.22);
}

.custom-confirm-dialog {
  padding: 28px 20px 22px;
}

.confirm-icon {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

.confirm-title {
  text-align: center;
  color: var(--text-primary);
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 16px;
}

.confirm-details {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 22px;
}

.detail-item,
.detail-row {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 14px;
  border-radius: 16px;
  background: #f6f9ff;
  border: 1px solid #e1ebfb;
}

.detail-label,
.detail-row span {
  color: var(--text-secondary);
  font-size: 14px;
}

.detail-value,
.detail-row strong {
  color: var(--text-primary);
  font-size: 14px;
  font-weight: 700;
  text-align: right;
  word-break: break-all;
}

.detail-row--block {
  flex-direction: column;
}

.detail-image {
  width: 100%;
  border-radius: 16px;
  margin-top: 8px;
}

.confirm-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.picker-popup,
.record-popup {
  padding: 18px;
}

.datetime-popup {
  padding: 18px 18px calc(18px + env(safe-area-inset-bottom));
}

.datetime-popup__actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 14px;
}

.datetime-popup ::v-deep .van-picker-column {
  touch-action: pan-y;
}

.datetime-popup ::v-deep .van-picker-column__wrapper {
  touch-action: pan-y;
}

.picker-popup__header,
.record-popup__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.picker-popup__header h3,
.record-popup__header h3 {
  margin: 0;
  color: var(--text-primary);
  font-size: 18px;
}

.picker-option,
.record-list__item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 14px 4px;
  border-bottom: 1px solid #eef3f9;
}

.record-list__title {
  color: var(--text-primary);
  font-size: 14px;
  font-weight: 700;
}

.record-list__desc {
  color: var(--text-secondary);
  font-size: 13px;
}

.back-btn {
  width: 42px;
  height: 42px;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  color: #1d2a39;
  font-size: 18px;
  box-shadow: 0 8px 20px rgba(25, 41, 72, 0.08);
}

.success-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 16px 20px 40px;
}

.success-icon {
  margin-bottom: 32px;
}

.success-title {
  color: #c9342f;
  font-size: 28px;
  line-height: 1.35;
  font-weight: 700;
  margin-bottom: 18px;
}

.success-meta {
  color: #c9342f;
  font-size: 20px;
  line-height: 1.6;
  font-weight: 700;
}

.success-links {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 36px 0 120px;
  color: #60779e;
  font-size: 16px;
}

.success-links button {
  border: none;
  background: transparent;
  color: #60779e;
  font-size: 16px;
  text-decoration: underline;
}

.success-action {
  width: min(520px, 100%);
  height: 54px;
  font-size: 18px;
  color: #fff !important;
  background: linear-gradient(135deg, #22b36b 0%, #168d56 100%) !important;
  border: none !important;
}

@media (max-width: 767px) {
  .person-in-page,
  .person-in-success {
    padding: 14px;
  }

  .page-hero,
  .record-card,
  .form-card {
    border-radius: 20px;
  }

  .page-hero h2 {
    font-size: 26px;
  }

  .phone-row {
    align-items: flex-end;
    flex-wrap: wrap;
  }

  .fetch-phone-btn {
    min-width: 96px;
    min-height: 36px;
    padding: 0 12px;
    margin-left: auto;
    font-size: 13px;
  }

  .detail-item,
  .detail-row {
    flex-direction: column;
    gap: 6px;
  }

  .detail-value,
  .detail-row strong {
    text-align: left;
  }

  .success-title {
    font-size: 24px;
  }

  .success-meta {
    font-size: 18px;
  }

  .success-links {
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 80px;
  }
}
</style>
